import { formatMoney } from '../../components/utilities';

const Customizations = {
  // Configura exibição do valor individual de cada personalização
  handleIndividualPrices: function (option, displayValue) {
    // Exibe o valor conforme seleção
    const value = Number(option.getAttribute('data-customization-price'));
    if (displayValue) {
      if (value > 0) {
        option.checked ? (displayValue.innerText = `+ ${formatMoney(value)}`) : (displayValue.innerText = '');
      } else {
        displayValue.innerText = '';
      }
    }
  },

  //Funcionamento de "fake" select
  handleSelectsDropdown: function () {
    const selects = document.querySelectorAll('[data-personalization-select]');

    selects.forEach((select) => {
      select.addEventListener('click', () => {
        const selectOptions = select.closest('.prod-option').querySelector('.select-options');
        select.classList.toggle('-active');

        if (selectOptions) {
          selectOptions.classList.toggle('-open');
        }
      });
    });
  },

  //Lida com o click nas opções do select
  //Altera o texto da caixa do select para a opção selecionada
  handleSelect: function () {
    const options = document.querySelectorAll('[data-select-option] .label');

    options.forEach((option) => {
      option.addEventListener('click', () => {
        Customizations.changeSelectPlaceholder(option);
        //Ao selecionar a opção sem personalização, desmarca a opção de gema selecionada e desabilita as opções de tipo
        //e atualiza o preço para 0
        if (option.hasAttribute('data-disable-selection')) {
          const displayValue = option.closest('[data-custom-option]').querySelector('[data-value]');
          Customizations.handleIndividualPrices(option, displayValue);
          Customizations.handleDisableSelect(option);
        } else {
          //Ao selecionar uma opção válida de personalização, habilita a seleção de tipo
          Customizations.handleEnableSelect(option);
        }
      });
    });
  },

  //Muda o texto placeholder no fake select e lida com os comportamentos do dropdown e da arrow
  changeSelectPlaceholder: function (option) {
    const selectOptionsWrapper = option.closest('.prod-option').querySelector('[data-select-option]');
    const selectedOption = option.closest('.prod-option').querySelector('[data-selected-option]');
    const activeOption = option.closest('.prod-option').querySelector('.label.-active');

    //Classe active para a opção sem personalização
    if (activeOption) {
      activeOption.classList.remove('-active');
    }
    option.classList.add('-active');

    if (selectedOption) {
      selectedOption.innerHTML = option.querySelector('.text').innerHTML;
    }

    //Fecha o fake select
    selectOptionsWrapper.classList.remove('-open');
    //Comportamento da arrow
    option.closest('.prod-option').querySelector('[data-personalization-select]').classList.remove('-active');
  },

  //Desativa o select de Tipo e desmarca todos os inputs de Gema
  handleDisableSelect: function (option) {
    const disableTarget = document.querySelector(
      '[data-custom-option][data-customization-name="tipo"]:not(.-inactive)'
    );
    const inputsToUncheck = option.closest('[data-custom-option]').querySelectorAll('input');
    inputsToUncheck.forEach((inputToUncheck) => {
      inputToUncheck.checked = false;
    });

    if (disableTarget) {
      const inputsToDisable = disableTarget.querySelectorAll('input');
      disableTarget.classList.add('-inactive');

      inputsToDisable.forEach((inputToDisable) => {
        inputToDisable.setAttribute('disabled', 'disabled');
      });
    }
  },

  //Habilita o select de Tipo
  handleEnableSelect: function () {
    const enableTarget = document.querySelector('[data-custom-option][data-customization-name="tipo"].-inactive');

    if (enableTarget) {
      const inputsToEnable = enableTarget.querySelectorAll('input');
      enableTarget.classList.remove('-inactive');

      inputsToEnable.forEach((inputToEnable) => {
        inputToEnable.removeAttribute('disabled');
      });
    }
  },

  //Muda o maxlength do input de texto de acordo com a opção de Modelo selecionada
  setInputLength: function (option) {
    const textInput = document.querySelector('[data-custom-option] [data-customization-text]');
    const openPreviewBtn = document.querySelector('[data-custom-option] [data-customizations-text-preview-button]');

    if (textInput) {
      textInput.value = '';
      textInput.setAttribute('maxlength', option.value);

      //Desativa o botão de preview após limpar o campo de texto
      Customizations.togglePreviewButton(textInput, openPreviewBtn);
    }
  },

  //Lida com os clicks no inputs em geral
  //Atualiza o preço de acordo com a opção selecionada
  //Se for personalização Modelo, atualiza o maxlength do input de texto
  handleOptions: function () {
    const customs = document.querySelectorAll('[data-custom-option]');
    customs.forEach((custom) => {
      const options = custom.querySelectorAll('[data-customization]');
      const displayValue = custom.querySelector('[data-value]');
      options.forEach((option) => {
        option.addEventListener('change', () => {
          Customizations.handleIndividualPrices(option, displayValue);
          if (option.hasAttribute('data-field-options')) {
            Customizations.setInputLength(option);
          }
        });
      });
    });
  },

  handlePopupPreview: function () {
    const textInput = document.querySelector('[data-custom-option] [data-customization-text]');
    const openPreviewBtn = document.querySelector('[data-custom-option] [data-customizations-text-preview-button]');
    const previewPopup = document.querySelector('[data-custom-option] [data-customizations-text-preview-popup]');
    if (textInput && openPreviewBtn && previewPopup) {
      openPreviewBtn.addEventListener('click', () => {
        previewPopup.classList.add('-active');
      });

      let closeButtons = previewPopup.querySelectorAll('[data-close]');
      if (closeButtons.length > 0)
        closeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            previewPopup.classList.remove('-active');
          });
        });

      let preview = previewPopup.querySelector('[data-preview]');
      textInput.addEventListener('change', () => {
        preview.innerHTML = textInput.value;
        Customizations.togglePreviewButton(textInput, openPreviewBtn);
      });
      textInput.value = '';
    }
  },

  togglePreviewButton: function (textInput, openPreviewBtn) {
    if (textInput.value == '' && !openPreviewBtn.classList.contains('-inactive')) {
      openPreviewBtn.classList.add('-inactive');
    } else if (textInput.value != '' && openPreviewBtn.classList.contains('-inactive')) {
      openPreviewBtn.classList.remove('-inactive');
    }
  },

  init: function () {
    this.handleSelectsDropdown();
    this.handleSelect();
    this.handleOptions();
    this.handlePopupPreview();
  },
};

export default Customizations;
